import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Heading from 'reusecore/src/elements/Heading';
import Container from '../../components/UI/Container';
import { SideBarStyle, List, ListItem } from './products-section.style';

// const TAGS = [
//   'fresnel',
//   'focos',
//   'escenarios',
//   'iluminacion-escenica',
//   'pisos-danza',
//   'estructuras',
//   'consolas',
//   'accesorios'
//   // 'elipso',
//   // 'consumibles',
//   // 'sistema-control',
//   // 'rosco',
//   // 'grandMA',
//   // 'gaffers'
// ];

const ProductListSideBar = props => {
  const { active = 'Productos', titleStyle, categoryTitle } = props;
  return (
    <SideBarStyle>
      <Container>
        <Heading as="h3" content="Categorías" {...titleStyle} />
        <List>
          <ListItem active={active === 'Productos'}>
            <Heading as="h4" {...categoryTitle}>
              <Link to="/productos">Todos</Link>
            </Heading>
          </ListItem>
          <ListItem active={active === 'Escénica'}>
            <Heading as="h4" {...categoryTitle}>
              <Link to="/productos/escenica">Escénica</Link>
            </Heading>
          </ListItem>
          <ListItem active={active === 'Arquitectural'}>
            <Heading as="h4" {...categoryTitle}>
              <Link to="/productos/arquitectural">Arquitectural</Link>
            </Heading>
          </ListItem>
        </List>
      </Container>
      {/* <Container>
        <Heading as="h3" content="Tags" {...titleStyle} />
        <List>
          {TAGS.map(tag => {
            const title = tag.charAt(0).toUpperCase() + tag.slice(1);
            return (
              <ListItem active={active === title} key={tag}>
                <Heading as="h4" {...categoryTitle}>
                  <Link to={`/productos/${tag}`}>{title}</Link>
                </Heading>
              </ListItem>
            );
          })}
        </List>
      </Container> */}
    </SideBarStyle>
  );
};

ProductListSideBar.propTypes = {
  titleStyle: PropTypes.object,
  categoryTitle: PropTypes.object
};

ProductListSideBar.defaultProps = {
  titleStyle: {
    color: 'headingColor',
    fontSize: ['15px', '16px', '16px', '18px', '18px'],
    fontWeight: '600',
    lineHeight: '1.34',
    mb: ['15px', '18px', '18px', '20px', '30px'],
    fontFamily: 'Poppins'
  },
  categoryTitle: {
    fontSize: ['15px', '16px'],
    lineHeight: '1.5',
    fontWeight: '600',
    color: 'purple',
    textAlign: 'left',
    fontFamily: 'Poppins',
    mb: '0px'
  }
};

export default ProductListSideBar;
